import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72dffe28"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-container",
    style: _normalizeStyle(`left: ${_ctx.position * +2}rem; background-image: url(${_ctx.image})`)
  }, [
    _createElementVNode("div", {
      title: _ctx.alt,
      class: "fade",
      style: _normalizeStyle(`background-image: url(${_ctx.image})`)
    }, null, 12, _hoisted_1)
  ], 4))
}